import { Common } from './common';
import { OrderMap, BaseOrderMap } from './models/orderMap';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(orderMap: BaseOrderMap): Promise<OrderMap> {
    const url = this.common.constructPath(`/order-maps`);
    return this.common.postJSON(url, orderMap);
  }
}
